<div class="eidos-alert-dialog">
  <h1 class="eidos-alert-dialog-title">{{ modalData.title ?? 'Error' }}</h1>
  <div class="eidos-alert-dialog-content">
    {{ modalData.info }}
  </div>
  <div class="eidos-alert-dialog-actions">
    <button class="eidos-button eidos-button-normal eidos-button-cancel" type="button" [cdkCopyToClipboard]="modalData.info">Copy info</button>
    <button class="eidos-button eidos-button-normal eidos-button-success" type="button" (click)="close()">Close</button>
  </div>
</div>
